import { render, staticRenderFns } from "./communication-messages.vue?vue&type=template&id=0c1ee4c1&scoped=true"
import script from "./communication-messages.vue?vue&type=script&lang=js"
export * from "./communication-messages.vue?vue&type=script&lang=js"
import style0 from "./communication-messages.vue?vue&type=style&index=0&id=0c1ee4c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_cache-loader@4.1.0_webpack@4.47.0__css-load_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ee4c1",
  null
  
)

export default component.exports